function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 7.7897 17.4552 5.67008 15.8924 4.10728C14.3296 2.54448 12.21 1.6665 9.99984 1.6665ZM9.99984 4.1665C11.3805 4.1665 12.4998 5.28579 12.4998 6.6665C12.4998 8.04722 11.3805 9.1665 9.99984 9.1665C8.61913 9.1665 7.49984 8.04722 7.49984 6.6665C7.49984 5.28579 8.61913 4.1665 9.99984 4.1665ZM9.99984 15.8222C11.8457 15.8222 13.5827 14.9485 14.6832 13.4665C14.8537 13.2172 14.876 12.8952 14.7415 12.6248L14.5498 12.2332C14.1305 11.3774 13.2612 10.8344 12.3082 10.8332H7.6915C6.72494 10.8342 5.84557 11.3923 5.43317 12.2665L5.25817 12.6332C5.12693 12.9013 5.14918 13.2192 5.3165 13.4665C6.41697 14.9485 8.15394 15.8222 9.99984 15.8222Z",
  fill: "#222222"
});

var SvgAccountCircleBlack = function SvgAccountCircleBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccountCircleBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AccountCircleBlack.5d5d7120.svg";
export { ForwardRef as ReactComponent };